import { render, staticRenderFns } from "./CpfInput.vue?vue&type=template&id=0587b346&scoped=true"
import script from "./CpfInput.vue?vue&type=script&lang=js"
export * from "./CpfInput.vue?vue&type=script&lang=js"
import style0 from "./CpfInput.vue?vue&type=style&index=0&id=0587b346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0587b346",
  null
  
)

export default component.exports